// Thin axios wrappers for the GM account-password-reset tool.

import axios from "axios";

export const searchAccounts = (q) => axios.get("/api/admin/accounts", { params: { q } }).then((r) => r.data);

export const setAccountPassword = (accountId, newPassword) =>
  axios.post(`/api/admin/accounts/${accountId}/password`, { new_password: newPassword }).then((r) => r.data);
